import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_urgency_message';
const urgencyMessageQuery = `
    query UnitMessage(
            $unitUuid: String!, 
            $dateRange: UrgencyDateRange, 
            $assetVersion: Int!, 
            $totalPrice: UnitTotalPrice, 
            $guests: UrgencyGuests
        ) {
        unitMessage(
            unitUuid: $unitUuid, 
            dateRange: $dateRange, 
            assetVersion: $assetVersion,
            guests: $guests,
            totalPrice: $totalPrice
        ) {
            iconText {
                message
                icon
                messageValueType
            }
        }
    }
`;

// eslint-disable-next-line complexity
async function urgencyMessageGraphQl({
    unitUuid,
    startDate,
    endDate,
    assetVersion,
    locale,
    adults,
    children,
    hasPets,
    currency,
    price
}) {
    let params = {unitUuid, assetVersion};

    if (startDate && endDate) {
        params.dateRange = {startDate, endDate};
    }

    if (currency && price) {
        params.totalPrice = {currency, totalPrice: price};
    }

    if (adults) {
        params.guests = {adults};
        if (children) {
            params.guests = {
                ...params.guests,
                children
            };
        }
        if (hasPets) {
            params.guests = {
                ...params.guests,
                petIncluded: hasPets
            };
        }
    }
    const mutatedResponse = await graphqlQuery(OPERATION_NAME, urgencyMessageQuery, params, locale);

    return ((mutatedResponse || {}).unitMessage || {}).iconText;
}

export default urgencyMessageGraphQl;
export {urgencyMessageGraphQl, OPERATION_NAME, urgencyMessageQuery};
